import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import {
    subscribeToOrgUserLocations,
    unsubscribeFromOrgUserLocations,
} from "features/pubsub/sockets/org-user-locations"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { socket } from "integrations/redux/store"
import { useEffect } from "react"

export const useOrgUserLocationSubscription = () => {
    const dispatch = useAppDispatch()
    const orgId = useAppSelector(selectActiveWorkspaceId())

    useEffect(() => {
        const activeSocket = socket
        if (!orgId || !activeSocket) return

        const subscribe = () => dispatch(subscribeToOrgUserLocations(orgId))
        subscribe()
        activeSocket.on("connect", subscribe)

        return () => {
            activeSocket.off("connect", subscribe)
            dispatch(unsubscribeFromOrgUserLocations(orgId))
        }
    }, [dispatch, orgId])
}
